import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import {
  getJobsFromAdvancedQuery,
  getCandidateStatsByJobIdsPostgres,
  IJob,
  IJobSearchFilterDTO,
  getJobsWorkAssignmentData,
  getPotentialRevenueForJobs,
  getInfoTemplateMappingsByJobIds,
  getEvaluationTemplateMappingsByJobIds,
} from 'wisestep-api';

import { paginationSettingsStore } from '../../../../utils/PaginationSettingStore';
import { candidateStatsDefaultQuery, jobCrmStatesCount } from '../JObSearchFilterDefaultQuery';
export interface PotentialRevenueDTO {
  id: string;
  potentialRevenue: number;
  potentialRevenueCurrency: string;
  potentialRevenueTimeSpan: string | null;
}

export interface IListingJobsState {
  jobListArr: (IJob & { isSelected: boolean })[];
  candidateStatsES: jobCrmStatesCount[];
  totalJobs: number;
  workAssignmentData?: Map<string, any>;
  potentialRevenueData?: PotentialRevenueDTO[];
  informationTemplateMappings?: [];
  evaluationTemplateMappings?: [];
}

const useListingJobs = (
  query: IJobSearchFilterDTO,
  setLoader: Dispatch<SetStateAction<boolean>>
): IListingJobsState => {
  const paginationData = paginationSettingsStore((state) => state.getPaginationSettings);
  const paginationSettings = paginationData();
  query.size = Number(paginationSettings?.jobsListPagination ?? 20);
  const [state, setState] = useState<IListingJobsState>({
    jobListArr: [],
    candidateStatsES: [],
    totalJobs: 0,
  });
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoader(true);
        const response = await getJobsFromAdvancedQuery({ ...query });
        const jobs = response.data;
        if (jobs) {
          const q = { ...candidateStatsDefaultQuery };
          const jobIds: string[] = [];
          jobs.filter((obj) => obj.id && jobIds.push(obj.id));
          q.jobIds = jobIds.toString();
          const candidateStats2 = await getCandidateStatsByJobIdsPostgres(q);
          const workAssignmentDataResponse = await getJobsWorkAssignmentData(jobIds);
          const potentialRevenue = await getPotentialRevenueForJobs(jobIds);
          const informationTemplateMappingsRes = await getInfoTemplateMappingsByJobIds(jobIds);

          const evaluationTemplateMappingsRes = await getEvaluationTemplateMappingsByJobIds(jobIds);
          setState((prev) => ({
            ...prev,
            jobListArr: jobs,
            candidateStatsES: candidateStats2.data ?? [],
            totalJobs: Number(response.headers['x-total-count']),
            workAssignmentData: workAssignmentDataResponse?.data,
            potentialRevenueData: potentialRevenue?.data,
            informationTemplateMappings: informationTemplateMappingsRes.data,
            evaluationTemplateMappings: evaluationTemplateMappingsRes.data,
          }));
        }
        setLoader(false);
      } catch (e) {
        setLoader(false);
      }
    };

    fetchJobs();
  }, [query, setLoader]);

  return state;
};

export default useListingJobs;
